import React from 'react';
import { Alert } from 'reactstrap';
import { parse } from 'query-string';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getProviderName } from 'shared/store/modules/provider/selectors';
import {
  selectIsStreamlinedSignUpFlowEnabled,
  selectIsResidentialRegistrationEnabled
} from 'shared/store/modules/features/selectors';
import { ErrorContainer, ErrorLink } from './AuthLayout.styles';
import CUSTOM_AUTH0_ERRORS from './Auth0Errors';

const AuthLayoutError = () => {
  const providerName = useSelector(getProviderName);
  const isStreamlinedFlowEnabled = useSelector(selectIsStreamlinedSignUpFlowEnabled);
  const isResidentialFlowEnabled = useSelector(selectIsResidentialRegistrationEnabled);

  const { search } = useLocation();
  const { error, error_type } = parse(search, { parseBooleans: true });

  if (!error) return null;

  const getMessage = (error, errorType) => {
    const getSignupUrl = () => {
      if (isStreamlinedFlowEnabled) {
        return <Link to="/signup">create an account</Link>;
      }
      if (isResidentialFlowEnabled) {
        return <Link to="/residential">create an account</Link>;
      }

      return 'create an account';
    };

    if (error.toString().includes('is not part of the org')) {
      errorType = 'no_user_in_shard';
    }

    const messages = {
      [CUSTOM_AUTH0_ERRORS.invalid_request]:
        'Your invitation appears to have expired, please reach out to customerservice@suncentral.net for help.',
      [CUSTOM_AUTH0_ERRORS.no_role]:
        'You may not have an account or a fully activated account.  Please reach out via the Contact Us link below for help.',
      [CUSTOM_AUTH0_ERRORS.no_accounts]:
        'You attempted to sign in with a different method than the one you used to create your account. Please try another method.',
      [CUSTOM_AUTH0_ERRORS.access_denied]:
        'You attempted to sign in with a different method than the one you used to create your account. Please try another method.',
      [CUSTOM_AUTH0_ERRORS.incorrect_login_method]:
        'You attempted to sign in with a different method than the one you used to create your account. Please try another method.',
      [CUSTOM_AUTH0_ERRORS.no_user_in_shard]: `You do not have an account with ${providerName} but you might have a community solar subscription with a different organization. Please reach out to customer service to log into the right organization`,
      [CUSTOM_AUTH0_ERRORS.no_such_user]: (
        <>
          We do not recognize your email. Please <ErrorLink>{getSignupUrl()}</ErrorLink> to sign up.
        </>
      ),
      [undefined]: 'Please try a different method or reach out to customerservice@suncentral.net for help.'
    };

    return messages[errorType];
  };

  return (
    <>
      <ErrorContainer>
        <Alert style={{ width: '500px', overflowWrap: 'break-word' }} color="danger">
          {getMessage(error, error_type)}
        </Alert>
      </ErrorContainer>
    </>
  );
};

export default AuthLayoutError;
